import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./style";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import AspectRatio from "react-aspect-ratio";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import "../../../src/css/serviceAlbum.css";
import Upload from "../descriptionComponent/selectUpload";
class InputFileReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: "",
      value: "",
      flagEdit: false,
      file: null,
      anchorEl: null,
    };
    this.handleClick = this.handleClick.bind(this);
    this.inputFileChanged = this.inputFileChanged.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setState({ src: this.props.defaultImg });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultImg !== this.props.defaultImg) {
      this.setState({ src: nextProps.defaultImg });
    }
  }

  inputFileChanged(e) {
    if (e.target.files[0]) {
      if (window.FileReader) {
        let file = e.target.files[0],
          reader = new FileReader(),
          self = this;
        reader.onload = function (r) {
          self.setState({
            src: r.target.result,
          });
        };
        reader.readAsDataURL(file);
        self.setState({
          value: reader,
          file: e.target.files[0],
          flagEdit: true,
        });
        if (this.props.type === "notPreview") {
          this.props.update(e.target.files[0]);
        }
      } else {
        alert("Sorry, your browser does'nt support for preview");
      }
    }
  }
  handleDelete = () => {
    this.setState({
      file: null,
      anchorEl: null,
      src: "",
      flagEdit: true,
    });
    if (this.props.type === "notPreview") {
      this.props.delete();
    }
  };
  getFlagEdit = () => {
    return this.state.flagEdit;
  };
  getFile = () => {
    return this.state.file;
  };
  getSrc = () => {
    return this.state.src;
  };
  handleClick = (event) => {
    const { disabled = false } = this.props;
    if (!disabled) this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleUpdate = () => {
    let input = this.refs.input_reader;
    input.click();
    this.setState({
      anchorEl: null,
    });
  };
  handleSelect = () => {
    this.Upload.open();
    this.setState({
      anchorEl: null,
    });
  };
  reset = () => {
    this.setState({
      src: this.props.defaultImg,
      value: "",
      flagEdit: false,
      file: null,
      anchorEl: null,
    });
  };
  selectImage = (image) => {
    this.Upload && this.Upload.close();
    if (
      this.props.selectStorageMode &&
      this.props.type === "notPreview" &&
      this.props.imageSelect
    ) {
      this.props.imageSelect(image);
    } else {
      this.setState({
        file: null,
        anchorEl: null,
        src: image,
        flagEdit: true,
      });
    }
  };
  render() {
    const {
      classes,
      accept,
      capture,
      multiple,
      t,
      container,
      cover = false,
      styleBg = {},
      width = true,
      ratio = 3,
    } = this.props;
    let { src = "/images/noneImage.svg", anchorEl } = this.state;
    if (container === "square") {
      return (
        <div
          className={
            width
              ? classes.containerImageWidth45vw
              : classes.containerImage + " container"
          }
        >
          <AspectRatio
            ratio={ratio}
            className={classes.image}
            style={{
              backgroundImage: `url(${src || "/images/noneImage.svg"})`,
              backgroundSize: "cover",
              ...styleBg,
            }}
          />
          <Upload
            onRef={(id) => (this.Upload = id)}
            selectStorageMode={this.props.selectStorageMode}
            selectImage={this.selectImage}
          />
          {cover && (
            <div
              className={classes.changeCover}
              style={{
                ...(styleBg.backgroundImage &&
                styleBg.backgroundImage === "none"
                  ? { display: "block" }
                  : {}),
              }}
            >
              <Button
                onClick={this.handleClick}
                size={"small"}
                variant="outlined"
              >
                <CloudUploadIcon />
                &nbsp;&nbsp;&nbsp;{t("change_cover")} ({t("ratio")} 3:1)
              </Button>
            </div>
          )}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => this.setState({ anchorEl: null })}
          >
            <MenuItem
              onClick={this.handleUpdate}
              className={classes.menuFontSize}
            >
              {t("file_reader_upload_photo")}
            </MenuItem>
            {this.props.selectStorageMode && (
              <MenuItem
                onClick={this.handleSelect}
                className={classes.menuFontSize}
              >
                {t("file_reader_select_image")}
              </MenuItem>
            )}
            <MenuItem
              onClick={this.handleDelete}
              className={classes.menuFontSize}
            >
              {t("file_reader_delete")}
            </MenuItem>
          </Menu>
          {!cover && (
            <div className={classes.camera} onClick={this.handleClick}>
              <img
                className={classes.iconCamera}
                src={"/images/photo_camera.svg"}
              />
            </div>
          )}
          <input
            type="file"
            ref="input_reader"
            accept={Array.isArray(accept) ? accept.join(",") : accept}
            multiple={multiple}
            capture={capture}
            style={{ display: "none" }}
            onChange={this.inputFileChanged}
          />
        </div>
      );
    } else {
      return (
        <div className={classes.containerArround + " container"}>
          <AspectRatio
            ratio={1}
            className={classes.containerImageRound}
            style={{
              backgroundImage: `url(${src || "/images/noneImage.svg"})`,
              backgroundSize: "cover",
            }}
          />
          <Upload
            onRef={(id) => (this.Upload = id)}
            selectStorageMode={this.props.selectStorageMode}
            selectImage={this.selectImage}
          />
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => this.setState({ anchorEl: null })}
          >
            <MenuItem
              onClick={this.handleUpdate}
              className={classes.menuFontSize}
            >
              {t("file_reader_upload_photo")}
            </MenuItem>
            {this.props.selectStorageMode && (
              <MenuItem
                onClick={this.handleSelect}
                className={classes.menuFontSize}
              >
                {t("file_reader_select_image")}
              </MenuItem>
            )}
            <MenuItem
              onClick={this.handleDelete}
              className={classes.menuFontSize}
            >
              {t("file_reader_delete")}
            </MenuItem>
          </Menu>
          <div className={classes.cameraRound} onClick={this.handleClick}>
            <img
              className={classes.iconCameraRound}
              src="/images/photo_camera.svg"
            />
          </div>
          <input
            type="file"
            ref="input_reader"
            accept={Array.isArray(accept) ? accept.join(",") : accept}
            multiple={multiple}
            capture={capture}
            style={{ display: "none" }}
            onChange={this.inputFileChanged}
          />
        </div>
      );
    }
  }
}
InputFileReader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
InputFileReader.defaultProps = {
  accept: "image/*",
  capture: true,
  multiple: false,
};
InputFileReader.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  capture: PropTypes.bool,
  multiple: PropTypes.bool,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(InputFileReader)
  )
);
